export default "__VITE_ASSET__CeBxQOsx__"